/*
  Copyright 2019 Bit Factory, Inc.
  This Source Code Form is subject to the terms of the Mozilla Public
  License, v. 2.0. If a copy of the MPL was not distributed with this
  file, You can obtain one at http://mozilla.org/MPL/2.0/.
*/
export var ProviderMethod;
(function (ProviderMethod) {
    ProviderMethod["EthAccounts"] = "eth_accounts";
    ProviderMethod["EthCall"] = "eth_call";
    ProviderMethod["EthCoinbase"] = "eth_coinbase";
    ProviderMethod["EthEstimateGas"] = "eth_estimateGas";
    ProviderMethod["EthGasPrice"] = "eth_gasPrice";
    ProviderMethod["EthGetBalance"] = "eth_getBalance";
    ProviderMethod["EthGetBlockByNumber"] = "eth_getBlockByNumber";
    ProviderMethod["EthGetFilterChanges"] = "eth_getFilterChanges";
    ProviderMethod["EthGetFilterLogs"] = "eth_getFilterLogs";
    ProviderMethod["EthGetTransactionReceipt"] = "eth_getTransactionReceipt";
    ProviderMethod["EthNewBlockFilter"] = "eth_newBlockFilter";
    ProviderMethod["EthNewFilter"] = "eth_newFilter";
    ProviderMethod["EthNewPendingTransactionFilter"] = "eth_newPendingTransactionFilter";
    ProviderMethod["EthRequestAccounts"] = "eth_requestAccounts";
    ProviderMethod["EthSendTransaction"] = "eth_sendTransaction";
    ProviderMethod["EthSign"] = "eth_sign";
    ProviderMethod["EthSignTypedData"] = "eth_signTypedData";
    ProviderMethod["EthSignTypedDataV3"] = "eth_signTypedData_v3";
    ProviderMethod["EthUninstallFilter"] = "eth_uninstallFilter";
    ProviderMethod["NetVersion"] = "net_version";
    ProviderMethod["PersonalECRecover"] = "personal_ecRecover";
    ProviderMethod["PersonalSign"] = "personal_sign";
})(ProviderMethod || (ProviderMethod = {}));
